export class GeolocationLib {
	
	constructor(library) {
		this._library = library;
	}

	get library(){return this._library;}
	set library(val){ throw new Error('library no modificable'); }
	
	async startLocation(){console.warn('startLocation no implementado')}
	async load(){console.warn('load no implementado')}
	async getLocation(){console.warn('getLocation no implementado')}
	async startLocation(){console.warn('startLocation no implementado')}
	async checkPermisions(){console.warn('checkPermisions no implementado')}
	async locationPermsCallback(){console.warn('locationPermsCallback no implementado')}
	async checkLocationSettings(){console.warn('checkLocationSettings no implementado')}
	async openLocationSettingsRes(){console.warn('openLocationSettingsRes no implementado')}
	async handleOnDestroy(){console.warn('handleOnDestroy no implementado')}
}

export class WebGPSGeolocation extends GeolocationLib {
    constructor(enableHighAccuracy=true, timeout=10000, maximumAge=0){
        super(navigator.geolocation)
        
        this.enableHighAccuracy = enableHighAccuracy;
        this.timeout = timeout;
        this.maximumAge = maximumAge;
        this.state = undefined;
        
        this.checkPermisions();
    }
    
    get config(){
        return {
            enableHighAccuracy: this.enableHighAccuracy,
			timeout: this.timeout,
			maximumAge: this.maximumAge
        }
    }
    
    async startLocation() {	return true	}
    
    
    
	async getLocation(){
		
		try{
		    
		    const self = this;
			const config = this.config;
			
			let resp = await new Promise((res,rej)=>self.library.getCurrentPosition(res, rej, config))
			const out = {}
			out.latitude = resp.coords.latitude;
			out.longitude = resp.coords.longitude;
			
			return out;
		}catch(err){
			console.error('getLocation err', err);
		}
	}
	async checkPermisions(){
		try {
			
			const self = this;
        
            let resp = await navigator.permissions.query({ name: "geolocation" })
            
            resp.onchange = (r) => {
            	
            };

            
            this.state = resp.state;
            
            return this.state;
		}catch(err){
			console.error('CapacitorGeolocation checkPermisions err', err);
		}
	}
// 	async handleOnDestroy(){
// 		const config = {
// 			id: this.watchId
// 		}
// 		let resp = this.library.clearWatch(config);
// 		return resp;
// 	} 
}

export function getGeolocation(){
    return new WebGPSGeolocation()
}